/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Author } from '../../models/author';
import { NewAuthor } from '../../models/new-author';

export interface EditorCreateAuthor$Params {
      body?: NewAuthor
}

export function editorCreateAuthor(http: HttpClient, rootUrl: string, params?: EditorCreateAuthor$Params, context?: HttpContext): Observable<StrictHttpResponse<Author>> {
  const rb = new RequestBuilder(rootUrl, editorCreateAuthor.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Author>;
    })
  );
}

editorCreateAuthor.PATH = '/editor/authors';
